// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"css-26ZGeZoyCz"};